import React from 'react';

import { openModal } from '@/mastodon/actions/modal';
import { browserHistory } from '@/mastodon/components/router';
import { useAppDispatch } from '@/mastodon/store';
import MediaIdCopy from '@paxsudos/frontend/MediaIdCopy.jsx';

const valueOf = (meta, key) => meta?.get?.(key) ?? meta?.[key];

const DetailedMediaMetaLinks = ({ attachments }) => {
  const dispatch = useAppDispatch();

  if (!attachments || attachments.size === 0) return null;

  const items = attachments.toArray().map((attachment) => {
    const exif = attachment?.getIn?.(['meta', 'paxsudos_exif']);
    const hasExif = !!(exif && (exif.size === undefined || exif.size > 0));

    const latitude = Number(valueOf(exif, 'latitude'));
    const longitude = Number(valueOf(exif, 'longitude'));

    const publishMap =
      attachment?.get?.('publish_map') === true ||
      attachment?.getIn?.(['meta', 'publish_map']) === true ||
      attachment?.getIn?.(['meta', 'paxsudos_publish_map']) === true;

    const onMap =
      hasExif &&
      Number.isFinite(latitude) &&
      Number.isFinite(longitude) &&
      publishMap;

    return { attachment, hasExif, onMap };
  });

  if (items.length === 0) return null;

  const openExif = (attachment) => (event) => {
    event.preventDefault();
    event.stopPropagation();

    dispatch(openModal({
      modalType: 'PAXSUDOS_MEDIA_METADATA',
      modalProps: { attachment },
    }));
  };

  const openMap = (attachment) => (event) => {
    event.preventDefault();
    event.stopPropagation();

    browserHistory.push(
      `/media-map?media=${encodeURIComponent(attachment.get('id'))}`,
    );
  };

  return (
    <>
      {items.map(({ attachment, hasExif, onMap }) => (
        <React.Fragment key={attachment.get('id')}>
          <span aria-hidden='true'>·</span>
          <MediaIdCopy id={attachment.get('id')} compact />

          {hasExif && (
            <>
              <span aria-hidden='true'>·</span>
              <button
                type='button'
                className='paxsudos-detailed-meta-link'
                onClick={openExif(attachment)}
              >
                EXIF
              </button>
            </>
          )}

          {onMap && (
            <>
              <span aria-hidden='true'>·</span>
              <button
                type='button'
                className='paxsudos-detailed-meta-link'
                onClick={openMap(attachment)}
              >
                Kartalla
              </button>
            </>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default DetailedMediaMetaLinks;
